import { render, staticRenderFns } from "./finally.vue?vue&type=template&id=028b510c&"
import script from "./finally.vue?vue&type=script&lang=js&"
export * from "./finally.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports